module.exports = __webpack_public_path__ + "img/gadgets_settings_normal@3x.b380b4c5.png";